<template>
  <div>
    <div
      v-if="origin == 'sidebar'"
      id="site_trigger"
    >
      <div
        v-if="variant === 'full'"
        class="site-selector"
        :class="{
          desktop: device === 'desktop',
          mobile: device !== 'desktop'
        }"
      >
        <div
          class="selector-wrapper"
          @click="open = !open"
        >
          <span>{{ currentSite.name }}</span>
          <div :class="['icon-full', open ? 'flipped' : '']">
            <ArrowRight />
          </div>
        </div>
        <transition name="navgroup">
          <div
            v-if="open"
            class="items"
          >
            <div
              v-for="item in sites"
              :key="item.guid"
              class="nav-site-item"
              @click="setSite(item)"
            >
              {{ item.title }}
            </div>
          </div>
        </transition>
      </div>
      <div
        v-else
        id="target-sites"
        class="site-selector desktop short"
        tabindex="0"
      >
        <div class="selector-wrapper short">
          <span> {{ currentSite.name }} </span>
        </div>
        <Tooltip
          target="target-sites"
          :text="$t('Menu.Items.Sites')"
        />
        <Popover
          :items="sites"
          target="target-sites"
          :title="$t('Menu.Items.Sites')"
        />
      </div>
    </div>
    <div v-if="origin == 'navbar' && device == 'tablet'">
      <div
        id="site_trigger"
        class="site-selector navbar"
        tabindex="0"
      >
        <div
          id="sites"
          class="selector-wrapper navbar"
        >
          <span> {{ currentSite.name }} </span>
          <div class="arrow-down">
            <ArrowDown class="arrow-down-icon" />
          </div>
        </div>
      </div>
      <Popover
        :items="sites"
        target="site_trigger"
        :title="$t('Menu.Items.Sites')"
        placement="down"
      />
    </div>
  </div>
</template>
<script>
  import ArrowRight from '@/assets/icons/arrow-right.svg';
  import ArrowDown from '@/assets/icons/arrow-down.svg';
  import Tooltip from '@/components/Menu/Tooltip.vue';
  import Popover from '@/components/Menu/Popover.vue';

  export default {
    name: 'SiteSelector',
    components: { ArrowRight, ArrowDown, Tooltip, Popover },
    props: {
      origin: {
        type: String,
        default: 'sidebar'
      },
      variant: {
        type: String,
        default: 'full'
      },
      device: {
        type: String,
        default: 'desktop'
      }
    },
    data: () => ({
      open: false,
      sites: [],
      currentSite: { name: '' }
    }),
    mounted() {
      this.getSites();
    },
    beforeDestroy() {
      this.open = false;
    },
    methods: {
      getSites() {
        const hasSites = JSON.parse(localStorage.getItem('sites'));

        if (!hasSites) return;

        this.currentSite = JSON.parse(localStorage.getItem('currentSite'));
        this.sites = JSON.parse(localStorage.getItem('sites')).map((item) => {
          return {
            title: item.name,
            click: () => this.setSite(item),
            ...item
          };
        });
      },
      setSite(site) {
        localStorage.setItem('currentSite', JSON.stringify(site));
        const userInfo = this.$cookies.get('userInfo');
        const domain = window.location.href.includes('indsiders.com');
        this.$cookies.set(
          'userInfo',
          { ...userInfo, currentSite: site },
          "7D",
          null,
          domain ? 'indsiders.com' : null
        );
        this.$router.go();
      }
    }
  };
</script>
<style lang="scss" scoped>
  .site-selector {
    width: 100%;
    transition: all 0.6s;

    cursor: pointer;
    user-select: none;
    color: #4c4541;
    display: flex;
    flex-direction: column;
    border-top: 1px solid #4c4541;
    background-color: transparent;
    transition: border 0s !important;

    max-width: 100% !important;

    &:hover {
      border-top: 1px solid #974900;
    }
    &.navbar {
      border-top: 0;
      border-left: 1px solid #eee;
    }

    .selector-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 8px;
      padding: 16px;
      border-bottom: 1px solid transparent;

      &.short {
        justify-content: center;
      }

      &:hover {
        background-color: #9749000d;
        border-bottom: 1px solid #974900;
        color: #974900;
        svg {
          fill: #974900;
        }
      }

      &:active {
        background-color: #97490029;
        svg {
          fill: #974900;
        }
      }

      .arrow-down {
        height: 100%;
        width: 16px;
        display: flex;
        align-items: center;
        svg {
          fill: #998f8a;
        }
        .arrow-down-icon {
          width: 16px;
          height: 16px;
        }
      }
    }

    .items {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
      padding-block: 12px;
      .nav-site-item {
        display: flex;
        padding: 8px 16px;
        align-items: center;
        gap: 8px;
        align-self: stretch;
        color: #998f8a;

        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        border-bottom: 1px solid transparent;
        border-top: 1px solid transparent;

        &:hover {
          border-bottom: 1px solid #974900;
          border-top: 1px solid #974900;
          background: rgba(151, 73, 0, 0.05);

          color: #fff;

          svg path {
            fill: #fff !important;
          }
        }

        &:active {
          border-top: 1px solid #974900;
          border-bottom: 1px solid #974900;
          background: rgba(151, 73, 0, 0.16);

          color: #fff;

          svg path {
            fill: #fff !important;
          }
        }
      }
    }

    .icon-full {
      width: 16px;
      height: 16px;

      display: flex;
      justify-content: center;
      align-items: center;
      svg {
        fill: #4c4541;
      }
      &.flipped {
        transform: rotate(90deg);
        transform-origin: center;
      }
    }

    span {
      overflow: hidden;
      text-align: center;
      font-variant-numeric: lining-nums proportional-nums;

      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 16px;
      color: #fff;

      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  @media (max-width: 768px) {
    .site-selector {
      &.navbar {
        height: 60px;
      }
    }
  }
</style>
